// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__5oZEx","content":"Sidebar_content__yvMVv","pane":"Sidebar_pane__uNMQt"};